import * as React from "react";
import H3 from "src/components/general/headings/H3";
import SlideoutButton from "src/components/general/SlideoutButton";
import YearPicker from "src/components/general/YearPicker";
import { defaultYear } from "src/constants/ApiSettings";

interface IProps {
  heading: string;
  alignment: string;
  learnMore?: any,
  subheading?: boolean,
  councilSays?: any,
  inverse?: boolean,
  year?: string,
  yearPicker?: any,
  children?: any;
}

const SectionHeading = (props: IProps) => {
  return (
  <div className={ 'section-heading' + ' section-heading--' + props.alignment }>
    <H3
      color={ props.inverse ? 'white' : 'cct-blue' }
      subheading={ props.subheading }
    >{ props.heading }</H3>
    <div className="section-heading__actions">
      { props.yearPicker && (
        <div className="section-heading__year">
          <YearPicker 
            onClick={ props.yearPicker }
            currentYear={ props.year ? props.year : defaultYear }
           />
        </div>
      )}
      <div className="section-heading__learn">
        { props.learnMore && (
          <SlideoutButton 
          label="Learn more" 
          inverse={ props.inverse } 
          section={ props.learnMore }
          year={ props.year ? props.year : defaultYear }
           />
        )}
        { props.councilSays && (
          <SlideoutButton 
          label="Council says" 
          inverse={ props.inverse } 
          section={ props.councilSays }
          year={ props.year ? props.year : defaultYear }
           />
        )}
      </div>
    </div>
  </div>
  )
};

export default SectionHeading;



// WEBPACK FOOTER //
// ./src/components/general/SectionHeading.tsx